import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '../../service/layout.service';

@Component({
  selector: 'app-floating-configurator',
  templateUrl: './app-floatingconfigurator.component.html',
  styleUrls: ['./app-floatingconfigurator.component.scss'],
  standalone: false,
})
export class AppFloatingConfiguratorComponent {
  layoutService = inject(LayoutService);

  isDarkTheme = computed(() => this.layoutService.layoutConfig().darkTheme);

  toggleDarkMode() {
    this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
  }
}
